import { useEffect } from 'react'

/**
 * Custom hook to manage scroll lock functionality with layout shift prevention.
 * When activated, it prevents body scrolling while compensating for scrollbar width
 * to avoid layout shift.
 *
 * @param isActive - Whether the scroll lock should be active.
 */
export const useScrollLock = (isActive: boolean): void => {
  useEffect(() => {
    if (isActive) {
      // Calculate scrollbar width
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth

      // Store original values for body
      const originalBodyOverflow = document.body.style.overflow

      // Set CSS custom property for scrollbar width
      document.documentElement.style.setProperty(
        '--scrollbar-width',
        `${scrollbarWidth.toString()}px`,
      )

      // Apply scroll lock and add class for CSS-based compensation
      document.body.style.overflow = 'hidden'
      document.body.classList.add('scroll-locked')

      return () => {
        // Restore original values
        document.body.style.overflow = originalBodyOverflow
        document.body.classList.remove('scroll-locked')
        document.documentElement.style.removeProperty('--scrollbar-width')
      }
    }

    // No cleanup needed when isActive is false
    return undefined
  }, [isActive])
}
